import { render } from "./SensorStatTemperature.vue?vue&type=template&id=5ac40a74"
import script from "./SensorStatTemperature.vue?vue&type=script&lang=js"
export * from "./SensorStatTemperature.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__